import axios from '@/api/axiosInstance';

export default async function checkExternalToken(provider) {
  const response = await axios({
    method: 'get',
    url: `${process.env.NEXT_PUBLIC_API}/auth/checkExternalToken`,
    params: { provider },
    preventRedirectOnUnauthorized: true,
  });
  return response.data;
}
